import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const statusBadgeWrapper = css`
  display: flex;
  gap: ${theme.spacing(1)};
`;
